import {createSlice} from "@reduxjs/toolkit"
const settingsSlice = createSlice({
    name:"settings",
    initialState: {formatCode: true},
    reducers:{
        changeFormatCode : (state, action) =>{
            state.formatCode = action.payload
        }
    }
})


export const { changeFormatCode } = settingsSlice.actions

export default settingsSlice.reducer

export const selectSettings = state=>state.settings